/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

import { createApp } from "vue";

const app = createApp({
    apiHost: Laravel.apiHost,
    data: function () {
        return _.omit(Laravel, (value, key) => {
            return key == "apiHost" || key == "csrfToken";
        });
    },
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the body of the page. From here, you may begin adding components to
 * the application, or feel free to tweak this setup for your needs.
 */

app.component(
    "passport-clients",
    require("./components/passport/Clients.vue").default
);

app.component(
    "passport-authorized-clients",
    require("./components/passport/AuthorizedClients.vue").default
);

app.component(
    "passport-personal-access-tokens",
    require("./components/passport/PersonalAccessTokens.vue").default
);

app.component(
    "donation-form",
    require("./components/donate/DonationForm.vue").default
);

app.component(
    "donate-container",
    require("./components/donate/DonateContainer.vue").default
);

app.component(
    "file-definition-dropdown",
    require("./components/donate/FileDefinitionDropdown.vue").default
);

app.component(
    "file-suggestion-dropdown",
    require("./components/donate/FileSuggestionDropdown.vue").default
);

app.component("loading-spinner", require("./components/donate/ui/LoadingSpinner.vue").default);

app.component(
    "charity-dropdown",
    require("./components/ui/CharityDropdown.vue").default
);

app.component(
    "poll-options",
    require("./components/ui/PollOptions.vue").default
);

app.component(
    "segment-definitions",
    require("./components/ui/SegmentDefinitions.vue").default
);

app.component("error-list", require("./components/ui/ErrorList.vue").default);

app.component("csrf-field", {
    template:
        '<input type="hidden" name="_token" value="' + Laravel.csrfToken + '">',
});


app.mount("#app");
